module.exports = __webpack_public_path__ + "img/logo-outline.8e7ac317.png";